@if (planUsage()) {
  <a class="flex flex-col rounded border border-border-3 p-4" [routerLink]="planAndUsagePath">
    <span class="text-xl font-medium leading-none text-primary">
      {{ name() }}
    </span>

    <div class="my-1 text-xs leading-none text-gray-500">
      @if (!isUsingFreePlan()) {
        <span> {{ startDate() }} - {{ nextChargeDate() }} </span>
      }
    </div>

    <div class="mt-5 flex items-center gap-2">
      <span class="text-xs text-gray-500">{{ 'common.ai-size-recommendation' | translate }}:</span>

      <span class="ml-auto text-right text-sm font-semibold leading-none text-primary">
        {{ aiSizeRecommendationUsage() }} /
        {{ aiSizeRecommendationLimit() }}
      </span>
    </div>

    <div class="relative mt-1 h-2 overflow-hidden rounded-lg bg-gray-300">
      <div
        class="absolute left-0 top-0 h-full rounded-lg"
        [ngClass]="aiSizeRecommendationState()"
        [style.width.%]="aiSizeRecommendationPerc()"
      ></div>
    </div>

    <div class="mt-1 flex items-center gap-2">
      <span class="text-xs text-gray-500">{{ 'common.stock-notification' | translate }}:</span>

      <span class="ml-auto text-right text-sm font-semibold leading-none text-primary">
        {{ stockNotificationUsage() }} /
        {{ stockNotificationLimit() }}
      </span>
    </div>

    <div class="relative mt-1 h-2 overflow-hidden rounded-lg bg-gray-300">
      <div
        class="absolute left-0 top-0 h-full rounded-lg"
        [ngClass]="stockNotificationState()"
        [style.width.%]="stockNotificationPerc()"
      ></div>
    </div>

    @let _sizeCharts = sizeCharts();
    @let _tableCharts = tableCharts();
    @if (_sizeCharts && _tableCharts) {
      <ng-container
        [ngTemplateOutlet]="chartUsageRow"
        [ngTemplateOutletContext]="{ label: 'common.published-size-charts', key: 'size-charts', row: _sizeCharts }"
      />
      <ng-container
        [ngTemplateOutlet]="chartUsageRow"
        [ngTemplateOutletContext]="{ label: 'common.published-table-charts', key: 'table-charts', row: _tableCharts }"
      />
    }
  </a>
}

<ng-template #chartUsageRow let-label="label" let-key="key" let-row="row">
  <div class="mt-1 flex items-center gap-2" [attr.data-cy]="'sidebar-' + key">
    <span class="text-xs text-gray-500">{{ label | translate }}:</span>

    <span
      class="ml-auto text-right text-sm font-semibold leading-none"
      [attr.data-cy]="'sidebar-' + key + '-count'"
      [class.text-primary]="!row.over"
      [class.text-red-500]="row.over"
    >
      {{ row.usage }} /
      {{ row.unlimited ? ('common.unlimited' | translate) : row.limit }}
    </span>
  </div>

  @if (row.showBar) {
    <div class="relative mt-1 h-2 overflow-hidden rounded-lg bg-gray-300">
      <div
        class="absolute left-0 top-0 h-full rounded-lg"
        [attr.data-cy]="'sidebar-' + key + '-bar'"
        [ngClass]="row.state"
        [style.width.%]="row.percent"
      ></div>
    </div>
  }
</ng-template>
